<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Document',
  },
})

const page = {
  groupTitle: 'Dokumen',
  icon: 'ri-file-text-line',
  color: 'primary',
  title: 'Kelola Dokumen (SOP/SK/Pedoman/Panduan)',
  description: 'Membuat draf, mengajukan review, menerbitkan, dan mengelola revisi dokumen terkendali.',
  purpose: 'Panduan lengkap siklus hidup satu dokumen QUALIVA — dari draf pertama sampai terbit resmi dan bisa dibaca seluruh staf.',
  concept: [
    {
      icon: 'ri-file-line',
      title: 'Dokumen vs Versi Dokumen',
      text: 'Satu "Dokumen" (mis. SOP Cuci Tangan) bisa punya banyak "Versi" seiring waktu direvisi. Nomor dokumen tetap sama, tapi nomor versi bertambah setiap kali direvisi ulang.',
    },
    {
      icon: 'ri-flow-chart',
      title: 'Alur Status: Draft → Review → Approved → Published',
      text: 'Setiap versi dokumen wajib melalui alur ini. Dokumen yang sudah "Published" tidak bisa diedit langsung — perubahan harus lewat versi baru (revisi), supaya riwayat lama tetap tersimpan utuh.',
    },
  ],
  steps: [
    { title: 'Buka menu Dokumen, klik "Buat Dokumen"', detail: 'Isi Kategori (SOP/SK/Pedoman/dst.), Unit pemilik, dan Judul dokumen. Nomor dokumen dibuat otomatis sesuai format kategori.' },
    { title: 'Klik "Ajukan Review"', detail: 'Dokumen pindah status ke Review dan alur persetujuan (Approval Flow) mulai berjalan sesuai yang sudah diatur admin.' },
    { title: 'Tunggu seluruh approver menyetujui', detail: 'Lihat progres persetujuan di halaman detail dokumen — status berubah ke Approved setelah semua approver menyetujui.' },
    { title: 'Klik "Terbitkan" (Publish)', detail: 'Aksi terpisah dari persetujuan — dokumen baru benar-benar bisa dibaca staf lain setelah Anda klik ini.' },
    { title: 'Perlu revisi? Klik "Buat Versi Baru"', detail: 'Versi lama tetap tersimpan dan bisa dilihat di tab "Riwayat Revisi", versi baru mulai dari status Draft lagi.' },
  ],
  tips: [
    'Isi Unit pemilik dokumen dengan benar sejak awal — ini menentukan siapa yang tampil sebagai pemilik di laporan.',
    'Dokumen yang sudah Published tidak bisa diedit judulnya langsung — kalau ada salah ketik, buat versi baru.',
    'Lampirkan file pendukung (PDF/gambar) lewat tombol Evidence di halaman detail versi — lihat panduan "Melampirkan Bukti (Evidence)".',
  ],
  faq: [
    { q: 'Kenapa saya tidak bisa mengedit dokumen yang sudah terbit?', a: 'Ini disengaja (BR-001) — dokumen resmi yang sudah terbit tidak boleh diubah diam-diam. Kalau ada revisi, buat versi baru lewat tombol "Buat Versi Baru" di halaman detail dokumen.' },
    { q: 'Siapa yang menentukan urutan approval sebuah dokumen?', a: 'Admin (biasanya Ketua Tim Mutu) yang mengatur Approval Flow lewat menu Administrasi → Approval Flow. Lihat panduan "Setup Approval Flow".' },
    { q: 'Apa bedanya kategori dokumen SOP dan SK?', a: 'Keduanya sama-sama jenis dokumen terkendali, bedanya cuma kategori dan format nomor dokumennya. Pilih kategori sesuai jenis dokumen yang sebenarnya Anda buat.' },
  ],
  related: [
    { title: 'Approval Dokumen', sub: 'Cara menyetujui atau menolak dokumen', icon: 'ri-checkbox-circle-line', color: 'success', to: { name: 'help-dokumen-approval-dokumen' } },
    { title: 'Melampirkan Bukti', sub: 'Upload file pendukung dokumen', icon: 'ri-attachment-2', color: 'info', to: { name: 'help-dokumen-lampiran-evidence' } },
    { title: 'Setup Approval Flow', sub: 'Atur siapa menyetujui apa', icon: 'ri-git-branch-line', color: 'warning', to: { name: 'help-administrasi-setup-approval-flow' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
